import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { articles, categories } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const filteredCategoryArticles = articles.filter((a) => a.category === slug);
  const categoryArticles = filteredCategoryArticles.length ? filteredCategoryArticles : articles;

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <p className="text-foreground-500">分类不存在</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="pt-20">
        <div className="mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]}
          />

          <div className="py-6 md:py-8">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${category.icon} text-primary-600 text-lg`}></i>
              </div>
              <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
                {category.name}
              </h1>
            </div>
            <p className="text-foreground-500 text-sm ml-13">{category.description}</p>
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 pb-14">
              {categoryArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="py-20 text-center">
              <div className="w-16 h-16 mx-auto flex items-center justify-center mb-3">
                <i className="ri-inbox-line text-3xl text-foreground-300"></i>
              </div>
              <p className="text-foreground-500">该分类下暂无文章</p>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}